import { render, staticRenderFns } from "./Sites.vue?vue&type=template&id=13040512&scoped=true"
import script from "./Sites.vue?vue&type=script&lang=js"
export * from "./Sites.vue?vue&type=script&lang=js"
import style0 from "./Sites.vue?vue&type=style&index=0&id=13040512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13040512",
  null
  
)

export default component.exports